











































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import CreateAccountData from '@/data/CreateAccount';

@Component
export default class CreateAccountView extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  mainKey = 0;

  UserData = CreateAccountData.initialUserData();

  UserType = CreateAccountData.UserType;

  handleRoleChange() {
    this.UserData.pt.general = this.UserData.role === 'MEMBER'
      ? this.AuthInstance.user.pt.general
      : 0;
    this.generateUser();
  }

  async generateUser() {
    const username = await this.AccountInstance.GenerateUser({ type: this.UserData.role });
    this.UserData.username = username;
  }

  async onSubmit() {
    const {
      status: {
        code, message,
      },
    } = await this.AccountInstance.CreateAccount(this.UserData);
    if (code === 0) {
      this.UserData = CreateAccountData.initialUserData();
      this.mainKey += 1;
    }
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
  }
}
